import callApi from '../../util/apiCaller';

import { setUsers } from '../User/UserActions';
import { setIsFetching, FETCH_LIMIT, getItemsRequest } from '../App/AppActions';
import { addError } from '../Error/ErrorActions';

// Export Constants
export const SET_USERGROUPS = 'SET_USERGROUPS';
export const REMOVE_USERGROUP = 'REMOVE_USERGROUP';

export function getUserGroupRequest(groupId) {
    return dispatch => {
        return callApi(`usergroup/${groupId}`).then(result => {
            if(result.userGroup) {
                dispatch(setUsers(result.userGroup.users));
                dispatch(setUserGroups([result.userGroup]));
            }
            return result.userGroup;
        }).catch(err => {
            return null;
        });
    };
}

export function getUserGroupsRequest(search = '', filters = null, sorter = null, pager = null) {
    return dispatch => dispatch(getItemsRequest('usergroups', 'userGroups', items => dispatch(setUserGroups(items)), { search, filters, sorter, pager }));
}

export function getUserGroupsCountRequest() {
    return dispatch => {
        return callApi('usergroups/count').then(result => {
            return result.count;
        }).catch(err => {
            return null;
        });
    };
}

export function editUserGroupRequest(userGroup) {
    return dispatch => {
        return callApi('usergroup/edit', 'post', { userGroup }).then(result => {
            dispatch(getUserGroupsRequest());
            return result.userGroup;
        }).catch(err => {
            return null;
        });
    };
}

export function addUsersToGroupRequest(userGroupId, userIds, fetchUsersGroup = true) {
    return dispatch => {
        return callApi(`usergroup/${userGroupId}/add/users`, 'post', { users: Array.isArray(userIds) ? userIds : [userIds] }).then(result => {
            fetchUsersGroup && dispatch(getUserGroupRequest(userGroupId));
            return result.ok;
        }).catch(err => {
            return null;
        });
    };
}

export function removeUserToGroupRequest(userGroupId, userIds) {
    return dispatch => {
        return callApi(`usergroup/${userGroupId}/remove/users`, 'post', { users: Array.isArray(userIds) ? userIds : [userIds] }).then(result => {
            dispatch(getUserGroupRequest(userGroupId));
            return result.ok;
        }).catch(err => {
            return null;
        });
    };
}

export function removeUserGroupRequest(userGroupId) {
    return dispatch => {
        return callApi('usergroup/remove', 'delete', { userGroup: { _id: userGroupId } }).then(result => {
            result && result.ok && dispatch(removeUserGroup(userGroupId));
            return result.ok;
        }).catch(err => {
            return null;
        });
    };
}

export function initUserGroupRequest() {
    return dispatch => {
        return callApi('usergroups/init').then(result => {
            result.ok && dispatch(getUserGroupsRequest());
            return result;
        }).catch(err => {
            return null;
        });
    };
}

// Getters
export function getUserGroups(store, institutions = null) {
    let groups = store.userGroups.data;
    if(institutions !== null) {
        if(!Array.isArray(institutions)) {
            institutions = [institutions];
        }
        groups = groups.filter(group => institutions.includes(group.institution));
    }
    return groups;
}

export function getUserGroup(store, id) {
    return store.userGroups.data.find(userGroup => userGroup._id === id);
}

// Export Actions
export function setUserGroups(userGroups) {
    return {
        type: SET_USERGROUPS,
        userGroups,
    };
}
export function removeUserGroup(userGroupId) {
    return {
        type: REMOVE_USERGROUP,
        userGroupId,
    };
}
